import Button from './ui/Button';

interface ErrorMessageProps {
  message?: string;
  onRetry?: () => void;
  fullScreen?: boolean;
}

/**
 * ErrorMessage component displays error states with optional retry functionality.
 * Can be used inline or as a full-screen message.
 */
export default function ErrorMessage({
  message = 'Something went wrong. Please try again.',
  onRetry,
  fullScreen = false,
}: ErrorMessageProps) {
  const content = (
    <div className="flex flex-col items-center justify-center gap-4 p-8">
      <div className="text-red-600 text-5xl">⚠️</div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Error Loading Data
        </h3>
        <p className="text-gray-600 text-sm max-w-md">{message}</p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} variant="secondary">
          Try Again
        </Button>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        {content}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      {content}
    </div>
  );
}
